import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { appName } from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Helmet } from "react-helmet";
import $ from 'jquery';
import { Row, Col, Table, Tabs, Tab, Modal } from 'react-bootstrap';
import Roles from '../../../utils/Roles';
import swal from 'sweetalert';
import Pagination from "react-js-pagination";
import Add from './Add';
import List from './List';
import PageTitle from '../../../containers/PageTitle';


class Interview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			acYear: Sanitize.getData('AcYear_id'),
			saveText: 'SELECT LIST',
			showAddModal: false,
			showListModal: false,
			deptList: [],
			dataList: [],
			chstatus: [],
			dataSelect: [],
			dept: ''
		}
		this.handleSearch = this.handleSearch.bind(this);
		this.oncheckChange = this.oncheckChange.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	componentDidMount() {

		this.loadDepartments();
		this.loadSelectedEmp();

	}

	loadDepartments() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('postcategory/getactivecategories/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ deptList: res['data'].data });
				this.setState({ showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({showLoader:false});	
			}
		});
	}

	loadEmployees() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('interview/getEmployee/' + this.state.dept + '/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ dataList: res['data'].data, showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				//this.setState({ showLoader: false });
			}
		});
	}

	loadSelectedEmp() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('interview/getSelectionList/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ dataSelect: res['data'].data, showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	handleSearch(e) {
		try {
			var list = this.state.dataList;
			var v = e.target.value.toUpperCase();
			var l = list.filter(function (obj) {
				const name = obj.name.toUpperCase();
				const mobile = obj.mobile.toUpperCase();
				const catname = obj.categoryname.toUpperCase();
				return ((name.indexOf(v) > -1) || (mobile.indexOf(v) > -1) || (catname.indexOf(v) > -1));
			});
			this.setState({ dataList: l });
		}
		catch (error) {
			console.log(error);
		}
	}

	onhandleChange(e) {
		this.state.dept = e.target.value;
		this.loadEmployees();
	}

	oncheckChange(id, sr, e) {
		if (e.target.checked) {
			this.state.chstatus.push({ "emp_id": id, seniority: sr });
			this.setState({ chstatus: this.state.chstatus });
		}
		else {
			notify.show("Please Select atleast one candidate", 'error');
		}
	}

	handleFormSubmit(e) {
		e.preventDefault();
		this.setState({ showLoader: true, saveText: 'Saving..' });
		Reqst.axPost('interview/saveSelection', this.state).then(res => {
			if (res['data'].status == '1') {
				notify.show(res['data'].msg, 'success');
				$("#dept").val();
				this.setState({ showLoader: false, saveText: 'SELECT LIST', chstatus: [] });
				$(".check").prop("checked", false);
				this.loadEmployees();
				this.loadSelectedEmp();
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false, saveText: 'SELECT LIST', chstatus: [] });
				$(".check").prop("checked", false);
				this.loadEmployees();
				this.loadSelectedEmp();
			}
		});
	}

	render() {

		return (
			<div>

				<Helmet>
					<title>{appName} | Interview Process</title>
				</Helmet>
				<PageTitle title="Interview Process" loading={this.state.showLoader} >
					<div className="text-right" >
						{Roles.Can('appointment', 'interview', 'canadd') ?
							<button className="btn btn-info btn-sm" onClick={() => { this.setState({ showAddModal: true }) }} >
								<i className="fa fa-plus"></i> Interview Setup
					</button> : null}	&nbsp;
						{Roles.Can('appointment', 'interview', 'canuse') ?
							<button className="btn btn-info btn-sm" onClick={() => { this.setState({ showListModal: true }) }} >
								<i className="fa fa-eye"></i> Interview Date
					</button> : null}
						&nbsp;
						<button className="btn btn-info btn-sm" onClick={this.loadData} >
							<i className="fa fa-refresh"></i>
						</button>
					</div>
				</PageTitle>
				<Row style={{ marginBottom: 5 }} >
					<Col md={9} >
						<div className="text-right" >

						</div>
					</Col>
				</Row>
				<Row>
					<Col md={12} >
						<Tabs defaultActiveKey="runselection" id="uncontrolled-tab-example">
							<Tab eventKey="runselection" title="Select Candidate"><br />
								<Row>
									<Col md={12}>
										<Row style={{ marginBottom: 5 }} >
											<Col md={3} >
												<input type="text" className="form-control input-sm" placeholder="Search Text..." onChange={this.handleSearch} />
											</Col>
											<Col md={3} >
												<select name="dept" id="dept" className="form-control input-sm" onChange={this.onhandleChange.bind(this)}>
													<option value="">Select Category</option>
													{this.state.deptList.map((item, i) =>
														<option value={item.id} >{item.categoryname}</option>
													)}
												</select>
											</Col>
											<Col md={3} ></Col>
											{this.state.dept != '' ?
												<Col md={3}>
													<div className="text-right" >
														<button onClick={this.handleFormSubmit} className="btn btn-success btn-sm" disabled={this.state.saveText != 'SELECT LIST'} >
															<i className="fa fa-check"></i> {this.state.saveText}
														</button>
													</div>
												</Col> : ''}
										</Row><br />
									</Col>
								</Row>
								<Row>
									<Col md={12} >
										<Table hover responsive className="list-table" >
											<thead>
												<tr>
													<th className="selcheckbox" >&nbsp;&nbsp;#</th>
													<th width="60" >SR.No</th>
													<th>Registration Year</th>
													<th>Year of Passing</th>
													<th>Candidate Name</th>
													<th>DOB</th>
													<th>Qualification</th>
													{/*<th>Address</th>*/}
													<th>Mobile</th>
												</tr>
											</thead>
											<tbody>
												{Object.keys(this.state.dataList).length > 0 ?
													this.state.dataList.map((item, key) => {
														return <tr key={key} >
															<td className="selcheckbox" ><input type="checkbox" className="check" data-appid={item.id} onChange={this.oncheckChange.bind(this, item.id, item.seniority)} /></td>
															<td>{item.seniority}</td>
															<td>{item.for_year}</td>
															<td>{Sanitize.getMonthName(item.passmonth)} {item.passyear}</td>
															<td>{item.name}</td>
															<td width="80">{Sanitize.dmyDash(item.dob)}</td>
															<td>{item.qualification}</td>
															{/*<td>{item.address} - {item.pincode}</td>*/}
															<td>{item.mobile}</td>
														</tr>;
													})
													: <tr>
														<td colSpan="10" align="center" style={{ fontSize: '18px', color: 'brown' }}>
															No data found..!
														</td>
													</tr>
												}
											</tbody>
										</Table>
									</Col>
								</Row>
								{this.state.dept != '' ?
									<Row>
										<Col md={12}>
											<div className="text-right" >
												<button onClick={this.handleFormSubmit} className="btn btn-success btn-sm" disabled={this.state.saveText != 'SELECT LIST'} >
													<i className="fa fa-check"></i> {this.state.saveText}
												</button>
											</div>
										</Col>
									</Row> : ''}
							</Tab>
							<Tab eventKey="selected" title="Selected List"><br /><br />
								<Row>
									<Col md={12} >
										<Table hover responsive className="list-table" >
											<thead>
												<tr>
													<th width="60" >SR.No</th>
													<th>Candidate Name</th>
													<th>Category</th>
													<th>Qualification</th>
													<th>Mobile</th>
													<th>Status</th>
												</tr>
											</thead>
											<tbody>
												{Object.keys(this.state.dataSelect).length > 0 ?
													this.state.dataSelect.map((item, key) => {
														return <tr key={key} className={(item.intstatus === 'completed' ? 'td_bg-green' : '')}>
															<td>{item.seniority}</td>
															<td>{item.name}</td>
															<td> {item.categoryname}</td>
															<td>{item.qualification}</td>
															<td>{item.mobile}</td>
															<td>{item.intstatus == 'pending' ? 'Called for Interview' : item.intstatus == 'completed' ? 'Appointed' : ''}</td>
														</tr>;
													})
													: <tr>
														<td colSpan="10" align="center" style={{ fontSize: '18px', color: 'brown' }}>
															No data found..!
														</td>
													</tr>
												}
											</tbody>
										</Table>
									</Col>
								</Row>
							</Tab>
						</Tabs>
					</Col>
				</Row>				
				<Modal size="md" show={this.state.showAddModal} onHide={() => { this.setState({ showAddModal: false }) }} className="right" >
					<Modal.Header closeButton >
						<Modal.Title>Interview Setup</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Add afterFinish={this.loadData} />
					</Modal.Body>
				</Modal>
				<Modal size="md" show={this.state.showListModal} onHide={()=>{this.setState({showListModal:false})}} className="right" >
					<Modal.Header closeButton >
						<Modal.Title>Interview Date</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<List afterFinish={this.loadData} />
					</Modal.Body>
				</Modal>
			</div>
		);
	}

}
export default Interview;